// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"8a6dfd77","453":"397482db","477":"7c0a5563","738":"c2e08626","779":"c1f59256"}[chunkId] + ".chunk.js";
};